import React from "react";

// Fallback layout for any service mix beyond Guards/Alarms-only (Systems
// branch, or any OTHER-kind service selected) - ported from
// quotation_pdf_builder.dart's _buildGenericQuotation. Portrait, itemized
// pricing table, maroon brand banner, validity note.
const BRAND_MAROON = "#6E1423";
const OFF_WHITE = "#FAF7F5";
const FONT_FAMILY = '-apple-system, "Segoe UI", Roboto, Helvetica, Arial, sans-serif';

const money = (n) => (Number(n) || 0).toFixed(2);
const trimZeros = (n) => (Number.isInteger(Number(n)) ? String(Number(n)) : String(Number(n)));

const GenericQuotationPreview = ({ enquiry, serviceTypes = [], company }) => {
  const validityDays = enquiry.quotationValidityDays || 30;

  const rows = [];
  if ((enquiry.guardsCount || 0) > 0) {
    rows.push(["Guards", enquiry.guardsCount, money(enquiry.guardsRate), money(enquiry.guardsAmount)]);
  }
  if ((enquiry.alarmsCount || 0) > 0) {
    rows.push(["Alarms", enquiry.alarmsCount, money(enquiry.alarmsRate), money(enquiry.alarmsAmount)]);
  }
  if ((enquiry.otherServicesAmount || 0) > 0) {
    rows.push(["Other services", "-", "-", money(enquiry.otherServicesAmount)]);
  }
  if ((enquiry.tempGuardsAmount || 0) > 0) {
    rows.push(["Temp Guards & Escorts", "-", "-", money(enquiry.tempGuardsAmount)]);
  }
  if ((enquiry.vatRate || 0) > 0) {
    rows.push(["VAT", "-", `${trimZeros(enquiry.vatRate)}%`, money(enquiry.vatAmount)]);
  }

  return (
    <div style={{ fontFamily: FONT_FAMILY, fontSize: 11, color: "#000", background: "#fff", padding: 24 }}>
      <div>
        <div style={{ fontSize: 20, fontWeight: "bold", color: BRAND_MAROON }}>{company?.name || "Texas Alarms"}</div>
        {company?.address && <div style={{ fontSize: 9, color: "#555" }}>{company.address}</div>}
        <div style={{ fontSize: 9, color: "#555" }}>
          {[company?.phone && `Tel: ${company.phone}`, company?.email].filter(Boolean).join("   |   ")}
        </div>
        <hr style={{ border: "none", borderTop: `1.5px solid ${BRAND_MAROON}`, margin: "8px 0" }} />
      </div>

      <div style={{ display: "inline-block", background: BRAND_MAROON, color: "#fff", padding: "8px 12px", borderRadius: 4, fontSize: 16, fontWeight: "bold", margin: "16px 0" }}>
        QUOTATION
      </div>

      <div style={{ display: "flex", justifyContent: "space-between", fontSize: 10, marginBottom: 16 }}>
        <span>Reference: {enquiry.enquiryNumber || "-"}</span>
        <span>Date: {new Date().toLocaleDateString("en-GB", { day: "numeric", month: "short", year: "numeric" })}</span>
      </div>

      <div style={{ background: OFF_WHITE, borderRadius: 4, padding: 10, marginBottom: 20 }}>
        <div style={{ fontSize: 12, fontWeight: "bold" }}>{enquiry.customerName || "Customer"}</div>
        <div style={{ fontSize: 10 }}>{enquiry.customerPhone}</div>
        {enquiry.customerEmail && <div style={{ fontSize: 10 }}>{enquiry.customerEmail}</div>}
        {enquiry.customerAddress && <div style={{ fontSize: 10 }}>{enquiry.customerAddress}</div>}
        {enquiry.area && <div style={{ fontSize: 10 }}>{enquiry.area}</div>}
      </div>

      {serviceTypes.length > 0 && (
        <div style={{ marginBottom: 16 }}>
          <div style={{ fontSize: 11, fontWeight: "bold" }}>Services Requested</div>
          <div style={{ fontSize: 10 }}>{serviceTypes.map((s) => s.serviceTypeName).join(", ")}</div>
        </div>
      )}

      <table style={{ width: "100%", borderCollapse: "collapse", border: "0.5px solid #ccc" }}>
        <thead>
          <tr style={{ background: BRAND_MAROON, color: "#fff" }}>
            <th style={{ padding: "6px 8px", textAlign: "left", fontSize: 10 }}>Description</th>
            <th style={{ padding: "6px 8px", textAlign: "center", fontSize: 10 }}>Qty</th>
            <th style={{ padding: "6px 8px", textAlign: "right", fontSize: 10 }}>Rate</th>
            <th style={{ padding: "6px 8px", textAlign: "right", fontSize: 10 }}>Amount</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((row, idx) => (
            <tr key={idx}>
              {row.map((cell, ci) => (
                <td
                  key={ci}
                  style={{
                    padding: "6px 8px",
                    fontSize: 10,
                    border: "0.5px solid #ccc",
                    textAlign: ci === 0 ? "left" : ci === 1 ? "center" : "right",
                  }}
                >
                  {cell}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>

      <div style={{ display: "flex", justifyContent: "flex-end", marginTop: 8 }}>
        <div style={{ background: OFF_WHITE, borderRadius: 4, padding: "8px 14px", fontSize: 13, fontWeight: "bold", color: BRAND_MAROON }}>
          Total: {money(enquiry.totalAmount)}
        </div>
      </div>

      {enquiry.adminPricingRemarks && (
        <div style={{ marginTop: 16 }}>
          <div style={{ fontSize: 11, fontWeight: "bold" }}>Remarks</div>
          <div style={{ fontSize: 10 }}>{enquiry.adminPricingRemarks}</div>
        </div>
      )}

      <hr style={{ border: "none", borderTop: "1px solid #ccc", margin: "24px 0 8px" }} />
      <div style={{ fontSize: 9, color: "#555", fontStyle: "italic" }}>
        This is a digitally generated quotation and does not require a physical signature. Valid for {validityDays} days from the date of issue.
      </div>
    </div>
  );
};

export default GenericQuotationPreview;
